import { Scene } from "pixi-scenegraph";
import { getScm, SceneBackGroundColor } from "../logic";
import { keyboardMapper } from "../Utils";
import { Texture, TilingSprite } from "pixi.js";

export class BasicScene extends Scene {
    private tile!: TilingSprite;
    
    constructor(sceneName: string, tilesTexture?:string) {
        super(sceneName);
        this.sceneName = sceneName;
        this.BackGroundColor = SceneBackGroundColor;
        this.tile = new TilingSprite({
            texture: Texture.from(tilesTexture || "/assets/forest-tile.png"),
            width: screen.width,
            height: screen.height,
        })
        this.addChild(this.tile);
    }
    
    protected sceneName : string;
    protected sceneManager = getScm();

    override onUpdate(dt: number, timestamp: number): void {
        if (this.sceneManager.IsDialogOpen) {
            keyboardMapper.update("Dialog");
        } else {
            keyboardMapper.update(this.sceneName);
        }

        Scene.enumerateChildren(this, (child) => {
            if ((child as any).onUpdate) {
                (child as any).onUpdate(dt, timestamp);
            }
        });
    }
    override onResize(): void {
        const screen = this.sceneManager.Renderer.screen;
        this.tile.width = screen.width;
        this.tile.height = screen.height
    }
}